module.exports = __webpack_public_path__ + "img/what_app.317d8485.png";